var _path, _path2, _path3, _rect, _g, _path4, _path5, _rect2, _g2, _rect3, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.217 169.139L118.245 169.8L121.382 207.67L129.355 207.01L126.217 169.139Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.8 169.4H162.8V207.4H170.8V169.4Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 220,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 220,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.3 232.4C170.772 232.4 189.8 230.161 189.8 227.4C189.8 224.639 170.772 222.4 147.3 222.4C123.828 222.4 104.8 224.639 104.8 227.4C104.8 230.161 123.828 232.4 147.3 232.4Z",
    fill: "#BFC3CE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.3 225.4C126.965 225.4 134.8 220.475 134.8 214.4C134.8 208.325 126.965 203.4 117.3 203.4C107.635 203.4 99.8 208.325 99.8 214.4C99.8 220.475 107.635 225.4 117.3 225.4Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.3 225.4C184.965 225.4 192.8 220.475 192.8 214.4C192.8 208.325 184.965 203.4 175.3 203.4C165.635 203.4 157.8 208.325 157.8 214.4C157.8 220.475 165.635 225.4 175.3 225.4Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 207,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 207,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.3 214.4C108.681 214.4 109.8 213.281 109.8 211.9C109.8 210.519 108.681 209.4 107.3 209.4C105.919 209.4 104.8 210.519 104.8 211.9C104.8 213.281 105.919 214.4 107.3 214.4Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 207,
    width: 10,
    height: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 207,
    width: 10,
    height: 10,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.3 214.4C187.681 214.4 188.8 213.281 188.8 211.9C188.8 210.519 187.681 209.4 186.3 209.4C184.919 209.4 183.8 210.519 183.8 211.9C183.8 213.281 184.919 214.4 186.3 214.4Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.2 52.6C169.2 53.9 168.7 55.1 167.9 56C166.9 56.5 165.9 57 164.9 57.6C156.7 62.5 151.2 71.4 151.2 81.6C151.2 81.7 151.2 81.8 151.2 81.9C150.3 81.7 149.3 81.6 148.2 81.6C146.8 81.6 145.4 81.8 144.2 82.1C143.5 79.7 143.2 77.2 143.2 74.6C143.2 62.4 150.9 52.1 161.8 48.2C162.4 48 163.1 47.8 163.7 47.6C163.9 47.6 164 47.6 164.2 47.6C167 47.6 169.2 49.8 169.2 52.6Z",
    fill: "#6E3126"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 133.3C80.5 133.3 67.5 148.3 69.5 151.3C71.5 154.3 78.5 156.3 82.5 158.3C86.5 160.3 96 169.3 91.7 170.8C87.4 172.3 83.9 173.3 82.2 170.8",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.8 125.5C209.8 129.5 209.1 132.5 208.8 134.5C206.8 146.5 201.8 155 195.5 164.8C184.4 182.1 165 193.5 142.9 193.5C108.4 193.5 83.8 165.4 80.4 131C79.8 125 78.9 119.4 79.6 113.8C79.7 112.7 79.8 111.7 79.8 110.6C79.9 108.1 80.2 105.3 80.8 102.5C81 101.2 81.5 99.4 81.6 98.1C81.6 97.9 81.6 97.8 81.7 97.6C81.7 97.4 81.8 97.2 81.8 97.1V97V96.9V96.8V96.7C81.8 96.6 81.8 96.6 81.8 96.5C81.8 96.4 81.8 96.3 81.8 96.3V96.2C84.6 78.8 99.7 65.5 117.8 65.5C122.6 65.5 127.3 66.4 131.5 68.1C132.1 68.5 132.7 68.8 133.3 69.2C134.7 70 136.2 70.7 137.7 71.3C141.9 73 146.5 74 151.4 74C153.4 74 155.3 73.8 157.2 73.5C159.4 73.2 161.5 72.6 163.5 71.9C163.9 71.8 164.3 71.6 164.7 71.5C168.1 70.2 171.7 69.4 175.4 69.5C176.9 69.6 178.4 69.7 180 70C197.7 72.9 210.5 88.7 210.5 106.7C210.5 113.3 210.8 118.8 209.8 125.5Z",
    fill: "#00D031"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210 125.5C210 129.5 209.3 132.5 209 134.6C207 146.7 202 155.3 195.7 165.1C184.6 182.5 165.3 194 143.3 194.1C157.2 189.6 169 180.3 176.7 168.2C183 158.4 188 149.8 190 137.7C190.3 135.9 190.9 133.3 191 129.8C191 129 191.1 128.2 191.2 127.4C192 121.1 191.7 115.9 191.7 109.6C191.6 91.4 181.6 76 163.8 73C163.6 73 160.7 72.4 160.5 72.4C161.6 72.1 162.6 71.8 163.7 71.4C164.1 71.3 164.5 71.1 164.9 71C168.3 69.7 171.9 68.9 175.6 69C177.1 69.1 178.6 69.2 180.1 69.5C197.8 72.5 210.6 88.3 210.6 106.5C210.6 113.2 210.9 118.7 210 125.5Z",
    fill: "#00BB42"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.3 116.4L100 123.6C99.9 126.1 97.8 128 95.3 127.9C92.8 127.8 90.9 125.7 91 123.2L91.3 116C91.4 113.5 93.5 111.6 96 111.7C98.5 111.8 100.4 113.9 100.3 116.4Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.9 82.2C114.9 83.7 114.3 85 113.4 86C113 86.3 112.7 86.5 112.4 86.8C108.1 90.6 105 95.8 103.9 101.7C103.8 102 103.8 102.3 103.7 102.6C103.1 104.9 100.9 106.6 98.4 106.6C95.6 106.6 93.4 104.6 93 102C93 101.6 92.9 101.2 92.9 100.8C92.9 100.6 92.9 100.3 92.9 100.1C92.9 90.5 98.2 82.1 106.2 77.6C106.6 77.4 107 77.1 107.5 76.9C108.1 76.7 108.8 76.5 109.4 76.5C112.4 76.7 114.9 79.2 114.9 82.2Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M203.9 133.3C203.9 133.3 212.9 168.3 197.9 186.3",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.3 128.4C124.89 128.4 127.8 124.371 127.8 119.4C127.8 114.429 124.89 110.4 121.3 110.4C117.71 110.4 114.8 114.429 114.8 119.4C114.8 124.371 117.71 128.4 121.3 128.4Z",
    fill: "#3A3A3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.3 128.4C166.89 128.4 169.8 124.371 169.8 119.4C169.8 114.429 166.89 110.4 163.3 110.4C159.71 110.4 156.8 114.429 156.8 119.4C156.8 124.371 159.71 128.4 163.3 128.4Z",
    fill: "#3A3A3A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.3 148.4C145.89 148.4 148.8 143.027 148.8 136.4C148.8 129.773 145.89 124.4 142.3 124.4C138.71 124.4 135.8 129.773 135.8 136.4C135.8 143.027 138.71 148.4 142.3 148.4Z",
    fill: "#3A3A3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_2",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_2",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_2",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_2",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGiAAAB/wAAAsj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACGAAADAQEAAAAAAAAAAAAAAAAABAUGAgEBAAAAAAAAAAAAAAAAAAAAABAAAAYCAwEBAAAAAAAAAAAAAAEDBAUGAgcgFhcQEhEAAgADBQYEBwAAAAAAAAAAAQIAAwQRITHREkGRkhOTBRCx0zVhcYHCgxREEgEAAAAAAAAAAAAAAAAAAAAg/9oADAMBAAIRAxEAAADF6fL6UpOpMDAABwLKMKECNWkn/9oACAECAAEFAOX/2gAIAQMAAQUA5f/aAAgBAQABBQBhFO5DJprd+qC1giEtbRGOHnEGPOIMecQYPXEIFtYtMs3WslscZOryEd8YKSSebacvSZFa7kRN7bZyPt8yO3zI7fMhW3T34O2XIO7FeVhJObCuY//aAAgBAgIGPwBf/9oACAEDAgY/AF//2gAIAQEBBj8A006g/FjYIVptQqocQBf5xfVvuGUATHd2GLaiLd0YvxHOMX4jnGL8Rzi4vxHOCZVU6qcFuNm8RbTVVp26wDd9LIYuVdFFpIuO7wJoBMLbeWpbyBhdFFUOgs/nm3j5gRf2WoP4Zvpwf2exVRGzRJmHzQR7DXdB8o9hrug+Uew13QfKDyuxVmvZqkPZbwmPZKjozfTgcvtlRJXaORNP2iGNck9FOKtLZAN48P/Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_2",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAFzAAABggAAAa7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABnAAEBAQAAAAAAAAAAAAAAAAAABQYBAQAAAAAAAAAAAAAAAAAAAAAQAQEBAQAAAAAAAAAAAAAAAAUAEAQRAAICAwAAAAAAAAAAAAAAABIEAREgkQMSAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQAAAIOdD//aAAgBAgABBQC//9oACAEDAAEFAL//2gAIAQEAAQUADIG7CN//2gAIAQICBj8Af//aAAgBAwIGPwB//9oACAEBAQY/AGmXe4McrCLEajU4f//Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.027037f0cecea0ab35d80af56252fdc5.svg";
export { ForwardRef as ReactComponent };